import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { Direction } from '@yandex-lego/components/Popup/desktop';
import { PageAboutMarketsProps } from 'client/bundles/types';
import Help from 'client/components/help';

import './index.css';

const b = cn('markets-table');

const HEADER_DIRECTIONS: Direction[] = ['top-center', 'bottom-center', 'top-right', 'bottom-right'];

interface Props {
    header: PageAboutMarketsProps['table-header'];
    markets: PageAboutMarketsProps['markets'];
}

class MarketsTable extends Component<Props> {
    private nodeRef = React.createRef<HTMLDivElement>();

    private get opponentsHelp() {
        return this.props.header.opponents.help;
    }

    private get opponentsLabel() {
        return this.props.header.opponents.label;
    }

    renderTableHeader() {
        const { header: { direction, units } } = this.props;

        return (
            <div className={b('header')}>
                <div className={b('header-direction')}>{direction.label}</div>
                <div className={b('header-group')}>
                    <div className={b('header-units')}>{units.label}</div>
                    <div className={b('header-opponents')} ref={this.nodeRef} >
                        <span className={b('header-opponents-label')}>{this.opponentsLabel}</span>
                        <Help
                            content={this.opponentsHelp}
                            mix={b('header-help')}
                            directions={HEADER_DIRECTIONS}
                            />
                    </div>
                </div>
            </div>
        );
    }

    renderTableBody() {
        const { markets } = this.props;

        return (
            <div className={b('table-body')}>
                {markets.map(({
                    name,
                    title,
                    subtitle,
                    description,
                    opponents,
                    logoList
                }) => (
                    <div key={name} className={b('table-row')}>
                        <div className={b('body-direction')}>
                            <h2 className={b('direction-title')}>{name}</h2>
                        </div>
                        <div className={b('body-group')}>
                            <div className={b('body-units')}>
                                <div className={b('units-header')}>
                                    <div className={b('units-logos')}>
                                        {logoList.reverse().map(logo => (
                                            <div key={logo} className={b('units-logo')} style={{ '--logo': `url(${logo})` } as React.CSSProperties} />
                                        ))}
                                    </div>
                                    <div className={b('units-titles')}>
                                        <div className={b('units-title')}>{title}</div>
                                        <div className={b('units-subtitle')}>{subtitle}</div>
                                    </div>
                                </div>
                                <div className={b('units-content')} dangerouslySetInnerHTML={{ __html: description }} />
                            </div>
                            <div className={b('body-opponents')}>
                                <div className={b('opponents-title')}>
                                    {this.opponentsLabel}:
                                    <Help
                                        content={this.opponentsHelp}
                                        mix={b('opponents-help')}
                                        />
                                </div>

                                <div dangerouslySetInnerHTML={{ __html: opponents }} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    render() {
        return (
            <div className={b()}>
                {this.renderTableHeader()}
                {this.renderTableBody()}
            </div>
        );
    }
}

export default MarketsTable;
